import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

import Awards from '../components/Awards'
import ChefAvatar from '../components/ChefAvatar'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Text from '../components/Text'
import Title from '../components/Title'

const Chef = () => (
  <Section id="onildo-rocha" paddingTop={120} paddingBottom={60} fluid>
    <Container>
      <Row justify="center" align="center">
        <Col xs={10} sm={10} md={8} lg={7}>
          <SectionHeading marginBottom={32}>
            <Row align="center">
              <Col xs={12} sm={6}>
                <ChefAvatar
                  data-sal="zoom-in"
                  data-sal-delay="300"
                  data-sal-easing="ease"
                  data-sal-duration="800"
                />
              </Col>
              <Col xs={12} sm={6} align="center">
                <Title
                  appearance="hero"
                  color="primary"
                  data-sal="slide-left"
                  data-sal-delay="300"
                  data-sal-easing="ease"
                  data-sal-duration="800"
                >
                  onildo rocha
                </Title>
              </Col>
            </Row>
          </SectionHeading>
          <SectionContent>
            <Text
              size={18}
              marginBottom={32}
              data-sal="slide-down"
              data-sal-delay="400"
              data-sal-easing="ease"
              data-sal-duration="800"
            >
              Chef responsável por introduzir a gastronomia no Movimento
              Armorial de Ariano Suassuna, extrapolando os limites do movimento
              e reinserindo a arte erudita no dia a dia das pessoas. Com uma
              gastronomia da memória, traz insumos locais vistos de uma ótica
              criativa e repleta de sabor, o que rendeu ao Roccia o título de
              Melhor Restaurante do Nordeste, pela Prazeres da Mesa, em 2017.
            </Text>
            <Awards />
          </SectionContent>
        </Col>
      </Row>
    </Container>
  </Section>
)

export default Chef
